import React, { useState } from "react";
import { motion } from "framer-motion";
import { SnailIcon, Volume2Icon } from "lucide-react";
import { speak } from "../../utils/speech";
import { spring } from "../../utils/motion";
interface SpeakButtonProps {
  text: string;
  lang: string;
  size?: "sm" | "lg";
  slow?: boolean;
  label?: string;
}
export function SpeakButton({
  text,
  lang,
  size = "sm",
  slow = false,
  label
}: SpeakButtonProps) {
  const [speaking, setSpeaking] = useState(false);
  const play = () => speak(text, lang, {
    onStart: () => setSpeaking(true),
    onEnd: () => setSpeaking(false)
  }, slow ? 0.55 : 0.9);
  const Icon = slow ? SnailIcon : Volume2Icon;
  const dims = size === "lg" ? "h-24 w-24 rounded-panel" : "h-10 w-10 rounded-xl";
  return <motion.button type="button" onClick={play} aria-label={label ?? `Listen${slow ? " slowly" : ""}`} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.94
  }} transition={spring.snappy} className={`focus-ring grid shrink-0 place-items-center border-3 border-line shadow-brutal-sm transition-colors duration-150 ${dims} ${speaking ? "bg-accent text-night" : size === "lg" ? "bg-brand text-white" : "bg-surface text-ink"}`} data-id="element-434" data-mp="2l5ozk83vbx45">
      <Icon className={size === "lg" ? "h-10 w-10" : "h-[18px] w-[18px]"} strokeWidth={2.5} aria-hidden="true" data-id="element-435" data-mp="2spmaqvb8ps40" />
    </motion.button>;
}